import { Assignments, Experiment, getBucket } from '@naturalcycles/shared'

export function getAb344DiscountBucket(assignments: Assignments): string | undefined {
  return getBucket(assignments[Experiment.DISCOUNTS_ON_CHECKOUT_SCREEN])
}

export function isAb344Test(bucket: string | undefined): boolean {
  return bucket === 'test'
}

export function isAb344Test2(bucket: string | undefined): boolean {
  return bucket === 'test2'
}

export function isAb344TestActive(bucket: string | undefined): boolean {
  return isAb344Test(bucket) || isAb344Test2(bucket)
}
